import cn from "classnames";
import styles from "./TableAndSearchMaster.module.scss";
import Table from "./Table";
import NewTableFilter from "./NewTableFilter";
import Search from "../common/Search";
import Button from "@material-ui/core/Button";
import { Modal } from "@mui/material";
import Select from "react-select";
import React, {
  useState,
  useEffect,
  useRef,
  Component,
  useCallback,
} from "react";
import { Link } from "react-router-dom";
import { getRequestInAssets } from "services/axiosAssetsBaseClient";
import {
  getSitePerformanceRequest,
  getSiteStatusRequest,
} from "../../services/axiosBaseClient";
import { getRequest, postRequest } from "services/axiosBaseClient";
import LocalStorageService from "services/tokenlocalstorage.service";
import { useLocation } from "react-router-dom";
import StoreFilter from "screen/FOTA/FirmwareStoreFilter";
import UpgradeFilter from "screen/FOTA/FirmwareUpgradeFilter";

var tempHeaderFilter;
var noData = [];
var tempBtnType;

function TableAndSearchMaster1(props) {
  return (
    <div className={cn(styles.block7, styles.block7_layout)}>
      <div className={cn(styles.flex5, styles.flex5_layout)}>
        <div className={cn(styles.flex4_spacer)} />
        <div id={"search_Box_" + props._id}>
          <Search
            onSearch={props.searchOpts.onSearch}
            placeholder={props.searchOpts.placeholder}
          />
        </div>

        <div id="data_table" style={{ overflowX: "auto", width: "100%" }}>
          <Table
            columns={props.columns}
            data={props.data}
            paginationDoubleScreen={props.paginationDoubleScreen}
          />
        </div>

        <div className={cn(styles.flex4_spacer)} />
      </div>
    </div>
  );
}

export default function NewTableAndSearchMasterFilter(props) {
  const location = useLocation();
  const { pathname } = location;
  const [timePeriod, setTimePeriod] = useState(props?.timeInfo);
  const splitLocation = pathname.split("/");

  const scrollRef = useRef(null);
  const scrollFun = () => {
    scrollRef?.current?.scrollTo(0, 0);
  };

  const filterInitialValue = {
    startDate: parseInt(Date.now() / 1000) - 86400,
    endDate: parseInt(Date.now() / 1000),
    siteId: props?.searchOpts?.disableFilter?.siteId
      ? props?.searchOpts.disableFilter.siteId
      : "",
    chargerId: props?.searchOpts?.disableFilter?.chargerId
      ? props?.searchOpts.disableFilter.chargerId
      : "",
    state: "",
    city: "",
    zoneId: "",
    cityId: null,
    stateId: null,
    time: timePeriod !== undefined ? timePeriod : "HOUR_24",
  };

  const [sitesList, setSitesList] = useState([]);
  const [chargerList, setChargerList] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [selectTime, setSelectTime] = useState(24);
  const [filter, setFilter] = useState(filterInitialValue);
  const [performanceData, setSitePerformanceData] = useState([]);
  const [performanceDataLabel, setSitePerformanceLabel] = useState([]);
  const [performanceDataLabelVal, setSitePerformanceLabelVal] = useState([]);
  const [resetText, setResetText] = useState(false);
  const [currentPageLimit, setCurrentPageLimit] = useState(10);
  const [filterChange, setFilterChange] = useState(true);
  const [filterAction, setFilterAction] = useState([0, 1]); //filterAction[0] => 0 for start, 1 for reset, 2 for apply, filterAction[1] => for changin
  const [searchString, setSearchString] = useState("");
  const [pSize, setPSize] = useState("");
  const [upgradeModalOpen, setUpgradeModalOpen] = useState(false);
  const [scheduleModalOpen, setScheduleModalOpen] = useState(false);

  const openUpgradeModal = () => {
    setUpgradeModalOpen(true);
  };

  const closeUpgradeModal = () => {
    setUpgradeModalOpen(false);
  };
  const openScheduleModal = () => {
    setScheduleModalOpen(true);
  };

  const closeScheduleModal = () => {
    setScheduleModalOpen(false);
  };
 
  const getSites = useCallback(async (filter) => {
    let callString = "bss/site/siteList";
    if (filter?.cityId > 0) {
      callString += "?cityId=" + filter.cityId;
      if (filter.stateId > 0) {
        callString += "&stateId=" + filter.stateId;
      }
      if (filter.zoneId > 0) {
        callString += "&zoneId=" + filter.zoneId;
      }
    } else if (filter?.stateId > 0) {
      callString += "?stateId=" + filter.stateId;

      if (filter.zoneId > 0) {
        callString += "&zoneId=" + filter.zoneId;
      }
    } else if (filter?.zoneId > 0) {
      callString += "?zoneId=" + filter.zoneId;
    }
    await getRequestInAssets(callString)
      .then((res) => {
        if (res.data != null) {
          setSitesList(res?.data);
          if (props?.searchOpts?.disableFilter?.chargerId) {
            getChargers(props?.searchOpts?.disableFilter?.siteId);
          }
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  const getChargers = useCallback(async (siteId) => {
    if (siteId == "" || siteId == null) {
      setChargerList([]);
      return null;
    }

    await getRequestInAssets(
      "bss/swappingStation/getswapStationInfo?siteId=" + siteId
    )
      .then((res) => {
        if (res.data != null) {
          setChargerList(res?.data?.swapStationList);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  const handleClick = (btnType) => {
    if (open) {
      if (btnType == "reset") {
        filter.time = filterInitialValue.time;
        filter.chargerId = "";
        filter.siteId = "";
        // setFilter(filterInitialValue);
        setFilter({ ...filterInitialValue, time: "HOUR_24" });
        setFilterAction([
          2,
          filterAction[1] == 0 ? 1 : 0,
          !filterChange ? 0 : 1,
        ]);
        setFilterChange(!filterChange);
        // props.onReset();
        setCurrentPageLimit(10);
        searchOnFilter(filterInitialValue, 0, 10, undefined);
        getSitePerformanceData("False", filter);
        setChargerList([]);
      } else if (btnType == "apply") {
        const valueCheck = localStorage.getItem("lastTableSearch");
        searchOnFilter(
          filter,
          0,
          10,
          typeof valueCheck === "object" ? "" : valueCheck
        );
        // searchOnFilter(filter);
        setFilterAction([
          2,
          filterAction[1] == 0 ? 1 : 0,
          !filterChange ? 0 : 1,
        ]);
        setFilterChange(!filterChange);
      } else {
        getSitePerformanceData("False", filter);
      }
      setOpen(false);
    } else {
      setOpen(true);
    }
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };
  const paginator = (page, pageSize, tigger, searchString) => {
    searchOnFilter(filter, page, pageSize, tigger, searchString);
  };

  useEffect(() => {
    tempBtnType = localStorage.getItem("headerBtnType");
    const valueCheck = localStorage.getItem("lastTableSearch");
    searchOnFilter(
      filter,
      0,
      10,
      props.tigger,
      typeof valueCheck === "object" ? "" : valueCheck
    );

    if (tempBtnType == "reset" || tempBtnType == "apply") {
      setFilterAction([2, filterAction[1] == 0 ? 1 : 0, !filterChange ? 0 : 1]);
    } else {
      setFilterAction([1, filterAction[1] == 0 ? 1 : 0, !filterChange ? 0 : 1]);
    }
    const headerFilterObj = JSON.parse(LocalStorageService.get("headerFilter"));
    getSites(headerFilterObj);
  }, [props.headerFilter]);

  const searchOnFilter = (filter, page, pageSize, tigger, searchString) => {
    setSearchString(searchString);
    const headerFilterObj = JSON.parse(LocalStorageService.get("headerFilter"));
    if (searchString === undefined || searchString === "") {
      setResetText(!resetText);
    }
    if (splitLocation[1] === "Invoice") {
      props.searchOpts.onFilterSearch(
        (searchString === undefined || searchString === ""
          ? ""
          : "invoiceNumber=" + searchString + "&") +
          (page === undefined || typeof parseInt(page) !== "number"
            ? "pageNumber=1"
            : "pageNumber=" + ++page) +
          (pageSize === undefined || typeof parseInt(pageSize) !== "number"
            ? "&pageSize=" + currentPageLimit
            : "&pageSize=" + pageSize) +
          (headerFilterObj?.stateId === undefined ||
          headerFilterObj?.stateId === ""
            ? ""
            : "&stateId=" + headerFilterObj.stateId) +
          (headerFilterObj?.cityId === undefined ||
          headerFilterObj?.cityId === ""
            ? ""
            : "&cityId=" + headerFilterObj.cityId) +
          (headerFilterObj?.zoneId === undefined ||
          headerFilterObj?.zoneId === ""
            ? ""
            : "&zoneId=" + headerFilterObj.zoneId)
      );
    } else if (splitLocation[1] === "Alerts") {
      props.searchOpts.onFilterSearch(
        (searchString === undefined || searchString === ""
          ? ""
          : "description=" + searchString) +
          (page === undefined || typeof parseInt(page) !== "number"
            ? "&offset=0"
            : "&offset=" + page) +
          (pageSize === undefined || typeof parseInt(pageSize) !== "number"
            ? "&pageSize=" + currentPageLimit
            : "&pageSize=" + pageSize) +
          (filter?.siteId === undefined || filter?.siteId === ""
            ? ""
            : "&siteId=" + filter.siteId) +
          (filter?.chargerId === undefined || filter?.chargerId === ""
            ? ""
            : "&swapStationId=" + filter.chargerId) +
          (filter?.time === undefined || filter?.time === ""
            ? ""
            : "&timeFilterEnum=" + filter.time) +
          (headerFilterObj?.stateId === undefined ||
          headerFilterObj?.stateId === ""
            ? ""
            : "&stateId=" + headerFilterObj.stateId) +
          (headerFilterObj?.cityId === undefined ||
          headerFilterObj?.cityId === ""
            ? ""
            : "&cityId=" + headerFilterObj.cityId) +
          (headerFilterObj?.zoneId === undefined ||
          headerFilterObj?.zoneId === ""
            ? ""
            : "&zoneId=" + headerFilterObj.zoneId)
      );
    } else if (splitLocation[1] === "Schedule") {
      const headerFilter =
        // (filter?.siteId === undefined || filter?.siteId === ""
        //   ? ""
        //   : "&siteId=" + filter.siteId) +
        // (filter?.chargerId === undefined || filter?.chargerId === ""
        //   ? ""
        //   : "&swapStationId=" + filter.chargerId)
        //   +
        // (filter?.time === undefined || filter?.time === ""
        //   ? ""
        //   : "&timeFilterEnum=" + filter.time)
        //    +
        (page === undefined || typeof parseInt(page) !== "number"
          ? "&offset=0"
          : "&offset=" + page) +
        (pageSize === undefined || typeof parseInt(pageSize) !== "number"
          ? "&limit=" + currentPageLimit
          : "&limit=" + pageSize) +
        (headerFilterObj?.stateId === undefined ||
        headerFilterObj?.stateId === ""
          ? ""
          : "&stateId=" + headerFilterObj.stateId) +
        (headerFilterObj?.cityId === undefined || headerFilterObj?.cityId === ""
          ? ""
          : "&cityId=" + headerFilterObj.cityId) +
        (headerFilterObj?.zoneId === undefined || headerFilterObj?.zoneId === ""
          ? ""
          : "&zoneId=" + headerFilterObj.zoneId);
      tempHeaderFilter = headerFilter;
      props.searchOpts.onFilterSearch(headerFilter);
    } else {
      props.searchOpts.onFilterSearch(
        (page === undefined || typeof parseInt(page) !== "number"
          ? "&offset=0"
          : "&offset=" + page) +
          (pageSize === undefined || typeof parseInt(pageSize) !== "number"
            ? "&limit=" + currentPageLimit
            : "&limit=" + pageSize) +
          (searchString === undefined || searchString === ""
            ? ""
            : splitLocation[1] === "sites"
            ? "&name=" + searchString
            : splitLocation[1] === "batteries"
            ? "&serialId=" + searchString
            : splitLocation[1] === "SwapStation"
            ? "&filter=" + searchString
            : splitLocation[1] === "Swapping"
            ? "&filter=" + searchString
            : "&filter=" + searchString) +
          (filter?.siteId === undefined || filter?.siteId === ""
            ? ""
            : "&siteId=" + filter.siteId) +
          (filter?.chargerId === undefined || filter?.chargerId === ""
            ? ""
            : "&swapStationId=" + filter.chargerId) +
          (filter?.time === undefined || filter?.time === ""
            ? ""
            : "&timeFilterEnum=" + filter.time) +
          (headerFilterObj?.stateId === undefined ||
          headerFilterObj?.stateId === ""
            ? ""
            : "&stateId=" + headerFilterObj.stateId) +
          (headerFilterObj?.cityId === undefined ||
          headerFilterObj?.cityId === ""
            ? ""
            : "&cityId=" + headerFilterObj.cityId) +
          (headerFilterObj?.zoneId === undefined ||
          headerFilterObj?.zoneId === ""
            ? ""
            : "&zoneId=" + headerFilterObj.zoneId)
      );
    }
  };

  const getSitePerformanceData = useCallback(async (e, filter) => {
    const payload = {
      city: "",
      endDate: filter.endDate,
      name: "",
      siteId: filter.siteId,
      startDate: filter.startDate,
      state: filter.state,
      zoneId: filter.zoneId,
    };
    // await getSitePerformanceRequest(
    //   "bss/getSiteperformance?topSites=" + e + "&timeFilterEnum=" + filter?.time
    // )
    await getRequest(
      "bss/getBatteryList?endDate=" +
        payload.endDate +
        "&siteId=" +
        payload.siteId +
        "&startDate=" +
        payload.startDate
    )
      .then((res) => {
        if (res && res?.data) {
          setSitePerformanceData(res?.data);
          var optionData = res;
          var arraLabel = [];
          var arraLabel = [];
          var arraLabelval = [];
          var arr1 = [];
          var colorArr = ["#9AAB04", "#1CAF9A", "#FF5C75"];
          optionData &&
            optionData?.data?.batteriesInfo?.map(
              (person, index) => (
                (arr1 = []),
                arraLabel.push(person.siteName),
                (arr1 = [person.start, person.max, person.end]),
                arraLabelval.push({
                  data: arr1,
                  emphasis: {
                    focus: "series",
                  },
                  type: "line",
                  smooth: true,
                  areaStyle: {
                    color: colorArr[index],
                  },
                })
              )
            );
          setSitePerformanceLabel(arraLabel);
          setSitePerformanceLabelVal(arraLabelval);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  const getTime = (val) => {
    const endTime = Math.round(new Date().getTime() / 1000);
    const startTime = endTime - val * 3600;

    filter.endDate = endTime;
    filter.startDate = startTime;
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFilter({ ...filter, [name]: value });

    if (event.target.name === "time") {
      setSelectTime(event.target.value);

      if (value === "HOUR_12") {
        setFilter({
          ...filter,
          startDate: parseInt(Date.now() / 1000) - 43200,
          endDate: parseInt(Date.now() / 1000),
          [name]: value,
        });
        setSelectTime("HOUR_12");
      }
      if (value === "HOUR_24") {
        setFilter({
          ...filter,
          startDate: parseInt(Date.now() / 1000) - 86400,
          endDate: parseInt(Date.now() / 1000),
          [name]: value,
        });
        setSelectTime("HOUR_24");
      }
      if (value === "WEEK") {
        setFilter({
          ...filter,
          startDate: parseInt(Date.now() / 1000) - 604800,
          endDate: parseInt(Date.now() / 1000),
          [name]: value,
        });
        setSelectTime("WEEK");
      }
      if (value === "WEEK_2") {
        setFilter({
          ...filter,
          startDate: parseInt(Date.now() / 1000) - 1209600,
          endDate: parseInt(Date.now() / 1000),
          [name]: value,
        });
        setSelectTime("WEEK_2");
      }
      if (value === "MONTH") {
        setFilter({
          ...filter,
          startDate: parseInt(Date.now() / 1000) - 2628000,
          endDate: parseInt(Date.now() / 1000),
          [name]: value,
        });
        setSelectTime("MONTH");
      }
      if (value === "MONTH_3") {
        setFilter({
          ...filter,
          startDate: parseInt(Date.now() / 1000) - 7884000,
          endDate: parseInt(Date.now() / 1000),
          [name]: value,
        });
        setSelectTime("MONTH_3");
      }
      if (value === null) {
        setFilter({
          ...filter,
          startDate: parseInt(Date.now() / 1000) - 86400,
          endDate: parseInt(Date.now() / 1000),
          [name]: value,
        });
        setSelectTime("HOUR_24");
      }
    }

    if (event.target.name == "siteId") {
      setFilter({ ...filter, [name]: value, chargerId: "" });
      getChargers(event.target.value);
    }
  };

  const refOpen = useRef(open);
  function useOutsideAlerter(ref, ref1) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setOpen(false);
          refOpen.current = false;
        } else {
          if (
            refOpen.current &&
            ref1.current &&
            !ref1.current.contains(event.target)
          ) {
            refOpen.current = false;
            setOpen(false);
          } else if (!ref.current && !ref1.current) {
            setOpen(false);
          } else {
            setOpen(true);
            refOpen.current = true;
          }
        }
      }

      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref, ref1]);
  }
  const wrapperRef = useRef(null);
  const wrapperRefInside = useRef(null);

  useOutsideAlerter(wrapperRef, wrapperRefInside);

  return (
    <div className={cn(styles.block25, styles.block25_layout)}>
      {props.checkBoxData && props.checkBoxData.length > 0 ? (
        <div className={cn(styles.flex6, styles.flex6_layout)}>
          <div className={cn(styles.flex7, styles.flex7_layout)}>
            <h1 className={cn(styles.flex10_heading)}>
              {props.checkBoxData.length} selected
            </h1>
            <div className={cn(styles.flex7_spacer)} />
            <div className={cn(styles.flex10_item)}>
              <button
                className={cn(styles.flex10_button1)}
                onClick={openScheduleModal}
              >
                Schedule an Upgrade
              </button>
              <button
                className={cn(styles.flex10_button2)}
                onClick={openUpgradeModal}
              >
                Upgrade now
              </button>
            </div>
          </div>
          <Modal open={upgradeModalOpen} onClose={closeUpgradeModal}>
            <div className={cn(styles.modal_Layout1)}>
              <img
                className={cn(styles.modal_closeImg)}
                src={require("assets/CloseBlueButton.svg").default}
                onClick={closeUpgradeModal}
              />
              <div className={cn(styles.modal_flex)}>
                <h3>Are you sure would you like to Upgrade?</h3>
                <select
                  name="version"
                  className={cn(
                    styles.line1,
                    styles.line1_layout,
                    styles.style_select
                  )}
                  type="select"
                >
                  <option value="" selected>
                    Select Firmware Version
                  </option>
                  <option>Active</option>
                  <option>Inactive</option>
                </select>
              </div>
              <div className={cn(styles.button_layout)}>
                <button
                  className={cn(styles.button_flex1)}
                  onClick={closeUpgradeModal}
                >
                  Cancel
                </button>
                <button className={cn(styles.button_flex2)}>
                  Upgrade Selected Stations
                </button>
              </div>
            </div>
          </Modal>
          <Modal open={scheduleModalOpen} onClose={closeScheduleModal}>
            <div className={cn(styles.modal_Layout2)}>
              <div className={cn(styles.modal_Layout1)}>
                <img
                  className={cn(styles.modal_closeImg)}
                  src={require("assets/CloseBlueButton.svg").default}
                  onClick={closeScheduleModal}
                />
                <div className={cn(styles.modal_flex)}>
                  <h3>Are you sure would you like to Schedule an Upgrade?</h3>
                  <select
                    name="version"
                    className={cn(
                      styles.line1,
                      styles.line1_layout,
                      styles.style_select
                    )}
                    type="select"
                  >
                    <option value="" selected>
                      Select Firmware Version
                    </option>
                    <option>Active</option>
                    <option>Inactive</option>
                  </select>
                </div>
                <div className={cn(styles.block3, styles.block3_layout)}>
                  <div
                    className={cn(styles.text_body, styles.text_body_layout)}
                  >
                    {"Select Schedule Date"}
                  </div>
                  <div className={styles.dateTimeContainer}>
                    <div className={styles.dateInputContainer}>
                      <input
                        name="Day"
                        className={cn(styles.line3, styles.line3_layout)}
                        maxLength="2"
                        placeholder="dd"
                      />
                      <span className={styles.dateSeparator}>/</span>
                      <input
                        name="Month"
                        className={cn(styles.line3, styles.line3_layout)}
                        maxLength="2"
                        placeholder="mm"
                      />
                      <span className={styles.dateSeparator}>/</span>
                      <input
                        name="Year"
                        className={cn(styles.line3, styles.line3_layout)}
                        maxLength="4"
                        placeholder="yyyy"
                      />
                    </div>
                    <img
                      style={{ height: "40px", width: "20px" }}
                      src={require("assets/Calendericon.svg").default}
                      onClick={closeScheduleModal}
                    />
                    <div className={styles.timeInputContainer}>
                      <input
                        name="Month"
                        className={cn(styles.line4, styles.line4_layout)}
                        maxLength="2"
                        placeholder="Time"
                      />

                      <select
                        name="version"
                        className={cn(
                          styles.line4,
                          styles.line4_layout,
                          styles.style_select
                        )}
                        type="select"
                      >
                        <option value="" selected>
                          AM/PM*
                        </option>
                        <option>AM</option>
                        <option>PM</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className={cn(styles.button_layout)}>
                  <button
                    className={cn(styles.button_flex1)}
                    onClick={closeScheduleModal}
                  >
                    Cancel
                  </button>
                  <button className={cn(styles.button_flex2)}>
                    Schedule Upgrade
                  </button>
                </div>
              </div>
            </div>
          </Modal>
        </div>
      ) : (
        <div className={cn(styles.flex6, styles.flex6_layout)}>
          <div className={cn(styles.flex7, styles.flex7_layout)}>
            {props.searchOpts.filter ? (
              <div className={cn(styles.flex5_item1)}>
                <div
                  ref={wrapperRef}
                  style={{ cursor: "pointer" }}
                  className={cn(styles.block26, styles.block26_layout)}
                >
                  <div className={cn(styles.block27, styles.block27_layout)}>
                    <div className={cn(styles.block28_spacer)} />
                    <div className={cn(styles.block27_item)}>
                      <img
                        src={require("assets/ic_filter.svg").default}
                        style={{ marginTop: "-1px", marginRight: "5px" }}
                      />
                    </div>
                    <div className={cn(styles.block27_spacer)} />
                    <div
                      id="filters_button"
                      ref={wrapperRef}
                      style={{ cursor: "pointer" }}
                      className={cn(
                        styles.text_body1,
                        styles.text_body1_layout
                      )}
                    >
                      {"Filters"}
                    </div>
                    <div>
                      {open && props.FilterOpts == "FirmwareStore" && (
                        <StoreFilter open={open} ref={wrapperRefInside} />
                      )}
                      {open && props.FilterOpts == "FirmwareUpgrade" && (
                        <UpgradeFilter open={open} ref={wrapperRefInside} />
                      )}
                    </div>

                    <div>
                      {open &&
                        props.FilterOpts !== "FirmwareStore" &&
                        props.FilterOpts !== "FirmwareUpgrade" && (
                          <div id="filter" open={open} ref={wrapperRefInside}>
                            <div
                              id="filter_box"
                              className={cn(
                                styles.status1_block,
                                styles.status1_block_layout
                              )}
                            >
                              <div id="filter_time_div">
                                <select
                                  style={{ width: "80%", height: "35px" }}
                                  name="time"
                                  id="time"
                                  onChange={handleChange}
                                  value={filter?.time}
                                >
                                  <option value="" disabled selected>
                                    Select Time Period
                                  </option>
                                  <option value="HOUR_24" selected>
                                    Last 24 hours
                                  </option>
                                  {/* <option value="24">Last 24 hours</option> */}
                                  <option value="HOUR_12">Last 12 hours</option>
                                  <option value="WEEK">Last 1 week</option>
                                  <option value="WEEK_2">Last 2 weeks</option>
                                  <option value="MONTH">Last 1 month</option>
                                  <option value="MONTH_3">Last 3 months</option>
                                </select>
                              </div>

                              <div id="filter_sites_div">
                                <select
                                  style={{ width: "80%", height: "35px" }}
                                  name="siteId"
                                  id="siteId"
                                  onChange={handleChange}
                                  value={filter.siteId}
                                  disabled={
                                    props?.searchOpts?.disableFilter?.siteId
                                  }
                                >
                                  <option value="" selected>
                                    Select Site
                                  </option>
                                  {sitesList?.map((obj) => {
                                    return (
                                      <option value={obj.id}>{obj.name}</option>
                                    );
                                  })}
                                </select>
                              </div>

                              <div id="filter_swap_station_div">
                                <select
                                  style={{ width: "80%", height: "35px" }}
                                  name="chargerId"
                                  id="chargerId"
                                  onChange={handleChange}
                                  value={filter.chargerId}
                                  disabled={
                                    props?.searchOpts?.disableFilter?.chargerId
                                  }
                                >
                                  <option value="" disabled selected>
                                    Select Swap Station
                                  </option>
                                  {chargerList &&
                                    chargerList?.map((obj) => {
                                      return (
                                        <option value={obj.swapStationId}>
                                          {obj.swapStationName}
                                        </option>
                                      );
                                    })}
                                </select>
                              </div>

                              <div id="filter_button">
                                <Button
                                  id="filter_rest_button"
                                  style={{
                                    background: "#E3324C",
                                    color: "white",
                                    margin: "15px 0px 6px 35px",
                                    width: "85px",
                                    height: "28px",
                                    lineHeight: "24px",
                                  }}
                                  onClick={() => {
                                    handleClick("reset");
                                  }}
                                >
                                  Reset
                                </Button>
                                <Button
                                  id="filter_apply_button"
                                  style={{
                                    background: "#23297A",
                                    color: "white",
                                    margin: "15px 0px 6px 20px",
                                    width: "85px",
                                    height: "28px",
                                    lineHeight: "24px",
                                  }}
                                  onClick={() => {
                                    handleClick("apply");
                                  }}
                                >
                                  Apply
                                </Button>
                              </div>
                            </div>
                          </div>
                        )}
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}

            {splitLocation[1] === "Schedule" ? (
              <>
                <h2
                  className={cn(
                    styles.medium_title,
                    styles.medium_title_layout
                  )}
                >
                  {"Schedule List"}
                </h2>
                <div className={cn(styles.flex7_spacer)} />
              </>
            ) : (
              <>
                <div className={cn(styles.flex7_spacer)} />
                <div className={cn(styles.flex7_item)}>
                  {props.searchOpts.placeholder ==
                  "Search by Swap Station Name" ? null : (
                    <Search
                      className={cn(styles.block8, styles.block8_layout)}
                      // className={cn(styles.flex7_item)}
                      // styles={{ width: "100%" }}
                      // onSearch={props.searchOpts.onSearch}
                      onSearch={searchOnFilter}
                      placeholder={props.searchOpts.placeholder}
                      filter={filter}
                      resetText={resetText}
                      setFilterAction={setFilterAction}
                      filterAction={filterAction}
                      _id={props._id}
                    />
                  )}
                </div>
              </>
            )}
            {props.searchOpts.buttonText === "invoice" ? (
              <div className={cn(styles.flex5_item1)}>
                <div style={{ flex: "0 0 max-content" }}>
                  <Link to="/Invoice/AddInvoice">
                    <div className={cn(styles.flex7_item1)}>
                      <div
                        className={cn(
                          styles.Invoiceblock26,
                          styles.Invoiceblock26_layout
                        )}
                      >
                        <div
                          className={cn(styles.block27, styles.block27_layout)}
                        >
                          <div className={cn(styles.block27_item)}>
                            <img
                              src={require("assets/Vector (5).png").default}
                              style={{ marginTop: "3px", marginRight: "5px" }}
                            />
                          </div>
                          <div className={cn(styles.block27_spacer)} />
                          <div
                            className={cn(
                              styles.text_body2,
                              styles.text_body2_layout
                            )}
                          >
                            {"Add Invoice"}
                          </div>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
            ) : props.searchOpts.buttonText === "schedule" ? (
              <div className={cn(styles.flex5_item1)}>
                <div style={{ flex: "0 0 max-content" }}>
                  <Link to="/Schedule/AddSchedule">
                    <div className={cn(styles.flex7_item1)}>
                      <div
                        className={cn(
                          styles.Invoiceblock26,
                          styles.Invoiceblock26_layout
                        )}
                      >
                        <div
                          className={cn(styles.block27, styles.block27_layout)}
                        >
                          <div className={cn(styles.block27_item)}>
                            <img
                              src={require("assets/Vector (5).png").default}
                              style={{ marginTop: "3px", marginRight: "5px" }}
                            />
                          </div>
                          <div className={cn(styles.block27_spacer)} />
                          <div
                            className={cn(
                              styles.text_body2,
                              styles.text_body2_layout
                            )}
                          >
                            {"Add Schedule"}
                          </div>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      )}

      <div className={cn(styles.box16, styles.box16_layout)}>
        {/* <Table columns={props.columns} data={props.data} /> */}
        {props?.data?.length < 1 || props?.data == null ? (
          <div style={{ overflowX: "auto" }}>
            <NewTableFilter
              columns={props.columns}
              data={noData}
              paginationDoubleScreen={props.paginationDoubleScreen}
            />
            {/* no_data_found_container */}
            <div
              id="no_data_found_container"
              className={cn(styles.no_data_found_container)}
            >
              <img
                src={
                  props.FilterOpts == "FirmwareStore" || props.FilterOpts == "FirmwareUpgrade"
                    ? require("assets/NoDataFound.svg").default
                    : require("assets/Search_No_data_Found.svg").default
                }
                height={"60px"}
                width={"60px"}
              ></img>
              {props.FilterOpts == "FirmwareStore" || props.FilterOpts == "FirmwareUpgrade" ? (
                <div className={cn(styles.no_data_found_label_1)}>
                  <h5 >
                    No Other Firmware Packages
                  </h5>
                  <p>Once Uploaded Firmware Packages will Appear Here</p>
                </div>
              ) : (
                <h5 className={cn(styles.no_data_found_label)}>
                  No Record Found
                </h5>
              )}

              {/* {window.scrollTo({ top: 0 })} */}
            </div>
          </div>
        ) : (
          <div
          // style={{ overflowX: "auto" }}
          >
            <NewTableFilter
              columns={props.columns}
              data={props.data}
              paginationDoubleScreen={props.paginationDoubleScreen}
              swapStationCount={props.swapStationCount}
              setCurrentPageLimit={setCurrentPageLimit}
              filterAction={filterAction}
              searchString={searchString}
              filter={filter}
              setPSize={setPSize}
              offset={props.offset}
              tigger={props.tigger}
              pageNumber={props.pageNumber}
              pageLimitHandle={paginator}
              paginationCountHanlde={props?.paginationCountHanlde}
              tempHeaderFilter={tempHeaderFilter}
            />
          </div>
        )}
      </div>
    </div>
  );
}
